/*!
 * is-posix-bracket <https://github.com/jonschlinkert/is-posix-bracket>
 *
 * Copyright (c) 2015-2016, Jon Schlinkert.
 * Licensed under the MIT License.
 */

module.exports = function isPosixBracket(str) {
  return typeof str === 'string' && /\[([:.=+])(?:[^\[\]]|)+\1\]/.test(str);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/is-posix-bracket/index.js
 ** module id = 75
 ** module chunks = 0
 **/